export default class LibrarySubscriptionValidationRule {
  public readonly MIN_SEATS = 0

  public totalOccupiedComparator(total: number, occupied: number) {
    if(Number(total) < this.MIN_SEATS) {
      return [`Total seats cannot be less than ${this.MIN_SEATS}`]
    }
    return Number(total) >= occupied ? [true] : ['Total seats exceeds current assigned seat count']
  }
  constructor() {}
}
  
